import { createSelector } from 'reselect';

/**
 * Direct selector to the app state domain
 */
const selectAppDomain = () => state => state.app;

const selectRouterDomain = () => state => state.router;

const selectLocationDomain = () => createSelector(
  selectRouterDomain(),
  substate => substate.location
);

const selectUser= () => createSelector(
  selectAppDomain(),
  substate => substate.user
);

/**
 * Other specific selectors
 */

const selectAuthToken = () => createSelector(
  selectAppDomain(),
  substate => substate.user && substate.user.authToken
);

const selectEnterpriseAdmins = () => createSelector(
  selectAppDomain(),
  substate => substate.user && substate.user.enterprise_admins
);

const selectEmail = () => createSelector(
  selectAppDomain(),
  substate => substate.user && substate.user.email
);

const selectIsPhotographer = () => createSelector(
  selectAppDomain(),
  substate => substate.user && substate.user.permission_role === 'photographer'
);

const selectPermissionRole = () => createSelector(
  selectAppDomain(),
  substate => substate.user && substate.user.permission_role
);

const selectPathname = () => createSelector(
  selectLocationDomain(),
  substate => substate.pathname
);

const selectSearch = () => createSelector(
  selectLocationDomain(),
  substate => substate.search
);

const selectHash = () => createSelector(
  selectLocationDomain(),
  substate => substate.hash
);

/**
 * Default selector used by App
 */

const selectApp = () => createSelector(
  selectAppDomain(),
  (substate) => substate
);

export default selectApp;
export {
  selectAppDomain,
  selectRouterDomain,
  selectUser,
  selectAuthToken,
  selectEmail,
  selectPathname,
  selectSearch,
  selectHash,
  selectIsPhotographer,
  selectPermissionRole,
  selectEnterpriseAdmins
};



// WEBPACK FOOTER //
// ./src/containers/App/selectors.js